import React, { Component } from "react";
import Header from "../HeadText/Head";
import './dStyle.css'

export default class Download extends Component {
  
  
  render() {
    let {type} = this.props; 

    return (
      <div id="try">
        <Header color="#fff" text="TRY" />
        <div className="container text-center">
          <p className="downloadApp col-md-12">
            Now it's time to {type === 'mobile' && "Download &"} Try App
          </p>
          <div className="row">
            {this.props.type === "mobile"?
            
            <div className="col-md-6">
              <a href={this.props.download} target="_blank" rel="noopener noreferrer">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/newpos-d06de.appspot.com/o/Portfolio%2Fassets%2Fimages.png?alt=media&token=958e3bcf-238f-4e62-b3f1-c71296f22848"
                  height="150vh"
                  width="50%"
                  className="down-img"
                  alt="download_img"
                />
              </a>
              </div>
            :
            <div className="col-md-6">
              <a href={this.props.url} target="_blank" rel="noopener noreferrer">
                {/* <img
                  src="https://firebasestorage.googleapis.com/v0/b/portfolio-789d4.appspot.com/o/images%2FGoogle-Play-Store.png?alt=media&token=0ebef3e1-5b81-4f47-be84-661f6cf4b12d"
                  height="150vh"
                  width="50%"
                  className="down-img"
                  alt="download_img"
                /> */}
                <button className="  btn btn-visit">Visit Website</button>
              </a>
              </div> 
            
            }
              <div className="col-md-6">
              <a href={this.props.repo} target="_blank" rel="noopener noreferrer">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/newpos-d06de.appspot.com/o/Portfolio%2Fassets%2Fimages.png?alt=media&token=958e3bcf-238f-4e62-b3f1-c71296f22848"
                  height="150vh"
                  width="50%"
                  className="down-img"
                  alt="github_Logo"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
